import React from 'react';
import { motion } from 'framer-motion';
import { HeartPulseIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { HERO_IMAGE } from '../../data/content';
export function Hero() {
  return <header className="w-full bg-cream px-4 pt-8 pb-12 sm:pt-12" data-id="element-184" data-mp="cutavzygpr5x">
      <div className="mx-auto w-full max-w-4xl text-center" data-id="element-185" data-mp="huxpfkft8bti">
        <div className="inline-flex items-center gap-2 rounded-full border border-navy/10 bg-white px-4 py-2" data-id="element-186" data-mp="hw8vjqwq9vns">
          <HeartPulseIcon className="h-4 w-4 text-brandred" aria-hidden="true" data-id="element-187" data-mp="mrxy8341nsob" />
          <span className="text-sm font-extrabold tracking-tight text-navy" data-id="element-188" data-mp="qu2r2zmo4l9w">
            Dra. Karito
          </span>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-6 font-display text-[30px] leading-[1.12] font-extrabold text-navy sm:text-5xl" data-id="element-189" data-mp="10lfixr8gvbfx">
          Resuelve cada caso de hipertensión con una ruta clínica clara en solo{' '}
          <span className="italic text-brandred" data-id="element-190" data-mp="9oua808z31y1">5 minutos</span> de consulta
        </motion.h1>

        <p className="mx-auto mt-5 max-w-2xl text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-191" data-mp="4nogq07hnang">
          Deja de improvisar frente a pacientes complejos. Sigue una ruta práctica
          que te dice exactamente qué hacer, desde el diagnóstico hasta el
          seguimiento, con el respaldo de las guías más recientes.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} src={HERO_IMAGE} alt="Ruta Hipertensión: 6 tomos clínicos, guías rápidas, checklist y versión digital" className="mx-auto mt-7 w-full max-w-2xl" data-id="element-192" data-mp="sgeri63nnnw5" />

        <div className="mt-6" id="hero-cta" data-id="element-193" data-mp="1b51umj29u373">
          <CTAButton label="Quiero mi Ruta Hipertensión ahora" size="lg" note="Descarga inmediata · Pago único · Acceso de por vida · Garantía 7 días" data-id="element-194" data-mp="1b6whi2x3s5dt" />
        </div>

        <p className="mt-6 text-sm font-semibold text-navy/70" data-id="element-195" data-mp="30o9vkn4v6l9r">
          Más de 2.000 médicos en Hispanoamérica ya usan Ruta Hipertensión para
          decidir con más rapidez, seguridad y confianza.
        </p>
      </div>
    </header>;
}